import _regenerator from "/usr/app/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/usr/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import React from "react";
var __jsx = React.createElement;
import { CDN_LINK } from "@globalConfig";
import { useRef, useState } from "react";
import { twMerge } from "tailwind-merge";
import rejectReasons from "@data/lookups/erp_price_offer_reason.json";
import { useLang } from "@/common/Contexts/LanguageContext";
import useHelpers from "@hooks/useHelpers";
import { useTranslation } from "@i18n";
import { trackEvents } from "@/common/events/events";
import useBrandsData from "@hooks/useBrandsData";
import { usePriceOfferContext } from "@/common/Contexts/PriceOfferContextProvider";
import Loader from "@componentsShared/Loader/Loader";
var PriceOfferRejectPage = function PriceOfferRejectPage() {
  var _useState = useState(null),
    selectedValue = _useState[0],
    setSelectedValue = _useState[1];
  var _useState2 = useState(false),
    isSubmitting = _useState2[0],
    setIsSubmitting = _useState2[1];
  var lang = useLang();
  var inputRef = useRef(null);
  var _useHelpers = useHelpers(),
    navigateTo = _useHelpers.navigateTo;
  var _useTranslation = useTranslation(),
    tShort = _useTranslation.tShort;
  var _useBrandsData = useBrandsData({
      forcedLang: "en"
    }),
    getMakeById = _useBrandsData.getMakeById,
    getModelById = _useBrandsData.getModelById;
  var _usePriceOfferContext = usePriceOfferContext(),
    constants = _usePriceOfferContext.constants,
    state = _usePriceOfferContext.state,
    remote_actions = _usePriceOfferContext.remote_actions;
  var data = state === null || state === void 0 ? void 0 : state.offerData;
  var request_id = state === null || state === void 0 ? void 0 : state.request_id;
  function handleCancelReasonSubmit(_x) {
    return _handleCancelReasonSubmit.apply(this, arguments);
  }
  function _handleCancelReasonSubmit() {
    _handleCancelReasonSubmit = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(selectedValue) {
      var _inputRef$current, rejection_reason, res;
      return _regenerator().w(function (_context) {
        while (1) switch (_context.p = _context.n) {
          case 0:
            if (!isSubmitting) {
              _context.n = 1;
              break;
            }
            return _context.a(2);
          case 1:
            if (selectedValue) {
              _context.n = 2;
              break;
            }
            return _context.a(2);
          case 2:
            setIsSubmitting(true);
            _context.p = 3;
            rejection_reason = selectedValue;
            if (selectedValue === "-1" && (_inputRef$current = inputRef.current) !== null && _inputRef$current !== void 0 && _inputRef$current.value) {
              rejection_reason = inputRef.current.value;
            }
            _context.n = 4;
            return remote_actions.fetch_priceOfferReject(rejection_reason);
          case 4:
            res = _context.v;
            if (res !== null && res !== void 0 && res.success) {
              navigateTo(constants.rejected_url(request_id));
            } else {
              console.error("Failed to submit rejection reason:", res);
            }
          case 5:
            _context.p = 5;
            setIsSubmitting(false);
            return _context.f(5);
          case 6:
            return _context.a(2);
        }
      }, _callee, null, [[3,, 5, 6]]);
    }));
    return _handleCancelReasonSubmit.apply(this, arguments);
  }
  return /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col gap-6"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col gap-4"
  }, /*#__PURE__*/React.createElement("div", {
    className: "text-center"
  }, /*#__PURE__*/React.createElement("img", {
    src: CDN_LINK + "/assets/images/reject-paper.svg",
    alt: "Offer rejected",
    height: "82",
    width: "96"
  })), /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col gap-4"
  }, /*#__PURE__*/React.createElement("h3", {
    className: "text-primary font-bold text-2xl text-center"
  }, tShort("price_offer/reject_reason_title", {
    ns: "web_sell_trade"
  }))), /*#__PURE__*/React.createElement("section", {
    className: "flex flex-col gap-4"
  }, rejectReasons.sort(function (a, b) {
    if (a.cancellation_reason_id === "-1") return 1;
    if (b.cancellation_reason_id === "-1") return -1;
    return 0;
  }).map(function (reason, index) {
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(RejectReasonOption, {
      name: "reject_reason",
      id: "reject_reason" + (index + 1),
      type: "radio",
      key: "reject_reason" + (index + 1),
      value: reason.cancellation_reason_id,
      reason: lang == "ar" ? reason.cancellation_reason_name_arabic : reason.cancellation_reason_name_english,
      onChange: function onChange(e) {
        return setSelectedValue(e.target.value);
      },
      checked: selectedValue === reason.cancellation_reason_id
    }));
  }), selectedValue === "-1" && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "w-full mt-[32px]"
  }, /*#__PURE__*/React.createElement("input", {
    type: "text",
    ref: inputRef,
    id: "other_reason",
    className: "text-netural-80 border border-solid border-neutral-10 p-3 w-full rounded text-base",
    placeholder: tShort("price_offer/reject_reason_placeholder", {
      ns: "web_sell_trade"
    })
  })))), /*#__PURE__*/React.createElement("div", {
    className: "absolute bottom-0 left-0 p-4 rounded-xl w-full shadow-[0_-4px_4px_0_rgba(0,0,0,0.04)] md:shadow-[none] md:relative md:p-0 md:mt-8 md:flex md:justify-center"
  }, /*#__PURE__*/React.createElement("button", {
    className: twMerge("" + "bg-danger text-white text-sm px-3 py-2 rounded w-full border-none outline-none hover:bg-danger-120 transition-colors duration-200 ease-in font-bold leading-6 min-h-12 cursor-pointer md:max-w-[200px] text-center", "disabled:bg-[#E8EFF6] disabled:text-[#92A5C1] disabled:cursor-not-allowed disabled:pointer-events-none", "relative"),
    disabled: selectedValue === null || isSubmitting,
    onClick: function onClick() {
      var _rejectReasons$find, _getMakeById, _getModelById;
      trackEvents("offer_rejected", {
        rejection_reason: (rejectReasons === null || rejectReasons === void 0 ? void 0 : (_rejectReasons$find = rejectReasons.find(function (reason) {
          return selectedValue === reason.cancellation_reason_id;
        })) === null || _rejectReasons$find === void 0 ? void 0 : _rejectReasons$find.cancellation_reason_name_english) || "",
        car_make: (_getMakeById = getMakeById(Number(data === null || data === void 0 ? void 0 : data.make_id))) === null || _getMakeById === void 0 ? void 0 : _getMakeById.name,
        car_model: ((_getModelById = getModelById(Number(data === null || data === void 0 ? void 0 : data.model_id))) === null || _getModelById === void 0 ? void 0 : _getModelById.name) || "",
        car_year: data === null || data === void 0 ? void 0 : data.year,
        offer_amount: data === null || data === void 0 ? void 0 : data.offer_price
      });
      handleCancelReasonSubmit(selectedValue);
    }
  }, tShort("price_offer/reject_reason_button_submit", {
    ns: "web_sell_trade"
  }), isSubmitting && /*#__PURE__*/React.createElement(Loader, {
    className: "!absolute !inset-0 !w-auto !h-auto !bg-transparent [&>span]:!w-5 [&>span]:!h-5 [&>span]:!border-2 [&>span]:after:!w-5 [&>span]:after:!h-5 [&>span]:after:!border-2"
  })))));
};
var RejectReasonOption = function RejectReasonOption(_ref) {
  var name = _ref.name,
    type = _ref.type,
    id = _ref.id,
    value = _ref.value,
    reason = _ref.reason,
    checked = _ref.checked,
    onChange = _ref.onChange,
    key = _ref.key;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "flex items-center gap-2",
    key: key
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex items-center"
  }, /*#__PURE__*/React.createElement("label", {
    htmlFor: id,
    className: "text-neutral-100 text-base font-regular cursor-pointer flex items-center gap-2"
  }, /*#__PURE__*/React.createElement("input", {
    id: id,
    type: type,
    name: name,
    value: value,
    checked: checked,
    onChange: onChange,
    className: "sr-only"
  }), /*#__PURE__*/React.createElement("div", {
    className: twMerge('w-6 h-6 rounded-full border flex items-center justify-center transition-all border-primary border-solid')
  }, checked && /*#__PURE__*/React.createElement("div", {
    className: "w-3 h-3 rounded-full bg-primary"
  })), reason))));
};
export default PriceOfferRejectPage;